import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c3a94640&"
import script from "./index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3a94640')) {
      api.createRecord('c3a94640', component.options)
    } else {
      api.reload('c3a94640', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c3a94640&", function () {
      api.rerender('c3a94640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/lpu/index.vue"
export default component.exports